/*
SHARE3DCAM 商品详情页自定义交互文件
文件名称：assets/share-pdp-custom.js

添加日期：2026-05-28
添加人：SHARE3DCAM 独立站运营 / Yulin

添加目的：
- 统一维护商品详情页 Product Detail Page 的自定义模块交互逻辑。
- 当前包含模块：SHARE Description Read More。
- 后续如新增购买前提醒、风险提示、使用说明等商品页自定义交互，建议继续在本文件中分区维护。

最新修改日期：2026-05-28
版本号：v1.0.0

维护说明：
- 不建议直接修改 theme.js，避免污染主题原生脚本。
- 每新增一个模块，请用清晰注释分区。
- 本文件只负责交互逻辑，不写样式。
*/


/* =========================================================
   模块 01：SHARE Description Read More
   作用：控制商品描述 Read more / Show less 展开收起
   文件关联：snippets/share-product-description-readmore.liquid
   样式关联：assets/share-pdp-custom.css
   添加日期：2026-05-28
   最新修改日期：2026-05-28
   ========================================================= */

(function () {
  var ROOT_SELECTOR = '[data-share-desc-readmore]';

  function getParts(root) {
    return {
      content: root.querySelector('[data-share-desc-content]'),
      button: root.querySelector('[data-share-desc-toggle]')
    };
  }

  function getText(root, type) {
    if (type === 'less') {
      return root.getAttribute('data-show-less-text') || 'Show less';
    }

    return root.getAttribute('data-read-more-text') || 'Read more';
  }

  function updateOverflow(root) {
    if (!root) return;

    var parts = getParts(root);
    if (!parts.content || !parts.button) return;

    var wasExpanded = root.classList.contains('is-expanded');

    /*
      先启用 is-ready，再临时移除展开状态。
      这样才能准确判断内容在折叠状态下是否超过默认行数。
    */
    root.classList.add('is-ready');
    root.classList.remove('is-expanded');

    window.requestAnimationFrame(function () {
      var needsReadMore = parts.content.scrollHeight > parts.content.clientHeight + 2;

      root.classList.toggle('has-overflow', needsReadMore);
      parts.button.hidden = !needsReadMore;

      if (wasExpanded && needsReadMore) {
        root.classList.add('is-expanded');
        parts.button.setAttribute('aria-expanded', 'true');
        parts.button.textContent = getText(root, 'less');
      } else {
        root.classList.remove('is-expanded');
        parts.button.setAttribute('aria-expanded', 'false');
        parts.button.textContent = getText(root, 'more');
      }
    });
  }

  function enhance(root) {
    if (!root) return;

    if (root.getAttribute('data-share-desc-enhanced') === 'true') {
      updateOverflow(root);
      return;
    }

    var parts = getParts(root);
    if (!parts.content || !parts.button) return;

    root.setAttribute('data-share-desc-enhanced', 'true');

    parts.button.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');

      parts.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      parts.button.textContent = expanded ? getText(root, 'less') : getText(root, 'more');
    });

    updateOverflow(root);
  }

  function initShareDescriptionReadMore() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      enhance(root);
    });
  }

  var resizeTimer;

  function handleResize() {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        updateOverflow(root);
      });
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareDescriptionReadMore);
  } else {
    initShareDescriptionReadMore();
  }

  window.addEventListener('load', initShareDescriptionReadMore);
  window.addEventListener('resize', handleResize);

  /*
    支持 Shopify 主题编辑器中的 section 重新加载。
    避免在 Customize 预览中新增/移动模块后交互失效。
  */
  document.addEventListener('shopify:section:load', initShareDescriptionReadMore);
})();







/* =========================================================
   模块 02：SHARE Purchase Notes
   作用：控制购买前须知模块的展开 / 收起交互
   文件关联：snippets/share-purch-notes.liquid
   样式关联：assets/share-pdp-custom.css
   添加日期：2026-06-01
   添加人：SHARE3DCAM 独立站运营 / Yulin
   最新修改日期：2026-06-01
   版本号：v1.0.0

   本次新增：
   - 桌面端：鼠标移入模块时展开，鼠标移出时收起。
   - 移动端：点击标题栏展开，再次点击收起。
   - 自动同步 aria-expanded 状态，提升基础可访问性。
   - 支持 Shopify 主题编辑器 section reload 后重新初始化。

   维护说明：
   - 本模块只负责交互逻辑，不写样式。
   - CSS 样式统一维护在 assets/share-pdp-custom.css。
   - 判断桌面端 / 移动端的断点与主题移动端断点保持一致：749px。
   ========================================================= */

(function () {
  var ROOT_SELECTOR = '[data-share-purch-notes]';
  var TOGGLE_SELECTOR = '[data-share-purch-toggle]';
  var DESKTOP_QUERY = '(min-width: 750px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function getToggle(root) {
    return root ? root.querySelector(TOGGLE_SELECTOR) : null;
  }

  function openNotes(root) {
    if (!root) return;

    var toggle = getToggle(root);

    root.classList.add('is-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  function closeNotes(root) {
    if (!root) return;

    var toggle = getToggle(root);

    root.classList.remove('is-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function toggleNotes(root) {
    if (!root) return;

    if (root.classList.contains('is-open')) {
      closeNotes(root);
    } else {
      openNotes(root);
    }
  }

  function enhancePurchaseNotes(root) {
    if (!root || root.getAttribute('data-share-purch-enhanced') === 'true') {
      return;
    }

    var toggle = getToggle(root);
    if (!toggle) return;

    root.setAttribute('data-share-purch-enhanced', 'true');

    /*
      桌面端：hover 展开 / 移出关闭。
      移动端：click 展开 / 收起。
      这里不把桌面端 click 作为主要交互，避免用户误触后状态卡住。
    */
    root.addEventListener('mouseenter', function () {
      if (isDesktop()) {
        openNotes(root);
      }
    });

    root.addEventListener('mouseleave', function () {
      if (isDesktop()) {
        closeNotes(root);
      }
    });

    toggle.addEventListener('click', function (event) {
      if (isDesktop()) {
        return;
      }

      event.preventDefault();
      toggleNotes(root);
    });
  }

  function initPurchaseNotes() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      enhancePurchaseNotes(root);
    });
  }

  function resetMobileStateOnResize() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      var toggle = getToggle(root);

      /*
        当从移动端切换到桌面端时，先关闭状态。
        避免移动端点击展开后，桌面端初始状态残留为展开。
      */
      if (isDesktop()) {
        root.classList.remove('is-open');

        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  var resizeTimer;

  function handlePurchaseNotesResize() {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      resetMobileStateOnResize();
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPurchaseNotes);
  } else {
    initPurchaseNotes();
  }

  window.addEventListener('load', initPurchaseNotes);
  window.addEventListener('resize', handlePurchaseNotesResize);

  /*
    支持 Shopify 主题编辑器中 section 重新加载。
    避免在 Customize 预览中新增 / 移动模块后交互失效。
  */
  document.addEventListener('shopify:section:load', initPurchaseNotes);
})();